module.exports = __webpack_public_path__ + "static/media/50th-logo--color.1b8b807a.svg";